"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5017],{

/***/ 33563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmptyProjectSlot; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52126);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67459);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69057);







function EmptyProjectSlot(param) {
    var onClick = param.onClick, groupId = param.groupId, text = param.text;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var textOrIntl = text || intl.formatMessage({
        defaultMessage: "Add another project",
        id: "B0aG5V"
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EmptyProjectSlotMobile, {
            groupId: groupId,
            text: textOrIntl
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EmptyProjectSlotContent, {
        onClick: onClick,
        text: textOrIntl
    });
};
function EmptyProjectSlotMobile(param) {
    var groupId = param.groupId, text = param.text;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/projects/create?groupId=".concat(groupId),
        as: "/projects/create",
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(EmptyProjectSlotContent, {
            text: text
        })
    });
}
function EmptyProjectSlotContent(param) {
    var text = param.text, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        "data-intercom-target": "Government Add Project",
        role: "button",
        "aria-label": text,
        css: {
            border: "dashed 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .innovatorBlue */ .LD),
            backgroundColor: "rgba(0, 90, 238, 0.03)",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            minHeight: 200,
            cursor: "pointer",
            "&:hover": {
                opacity: 0.7
            }
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                css: {
                    width: 46,
                    height: 46,
                    border: "dashed 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .innovatorBlue */ .LD),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100%"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("svg", {
                    width: 22,
                    height: 22,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("path", {
                        fill: "#005AEE",
                        fillRule: "evenodd",
                        d: "M20.894 10.06h-9.286V.774a.773.773 0 1 0-1.548 0v9.286H.774a.773.773 0 1 0 0 1.548h9.286v9.286a.773.773 0 1 0 1.548 0v-9.286h9.286a.773.773 0 1 0 0-1.548z"
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_1__/* .Margin */ .Zt, {
                mt: 8,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                    css: {
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.1,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .innovatorBlue */ .LD
                    },
                    children: text
                })
            })
        ]
    });
}


/***/ }),

/***/ 18290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94070);
/* harmony import */ var _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42046);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateProjectForGovernment($project: ProjectInput!, $government: ObjectId!) {\n    createProjectForGovernment(project: $project, government: $government) {\n      _id\n      ...GroupProjectFields\n      ...GovernmentProjectFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ }),

/***/ 42191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94070);
/* harmony import */ var _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42046);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateProjectForGroup($project: ProjectInput!, $group: ObjectId!) {\n    createProjectForGroup(project: $project, group: $group) {\n      _id\n      ...GroupProjectFields\n      ...GovernmentProjectFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ }),

/***/ 99146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94070);
/* harmony import */ var _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42046);
/* harmony import */ var _lib_queries_fragments_VendorProjectFields__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4511);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateProjectForVendor($project: ProjectInput!, $vendor: ObjectId!) {\n    createProjectForVendor(project: $project, vendor: $vendor) {\n      _id\n      ...GroupProjectFields\n      ...GovernmentProjectFields\n      ...VendorProjectFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_GroupProjectFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _lib_queries_fragments_GovernmentProjectFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _lib_queries_fragments_VendorProjectFields__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 60942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AutoCompleteGroups($searchQuery: String!, $groupKinds: [String!], $limit: Int!) {\n    autoCompleteGroups(searchQuery: $searchQuery, groupKinds: $groupKinds, limit: $limit) {\n      _id\n      name\n      slug\n      logo\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 42046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57148);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment GovernmentProjectFields on GovernmentProject {\n    _id\n    icon\n    title\n    slug\n    tags {\n      _id\n      ...TagFields\n    }\n    awards {\n      _id\n      slug\n      name\n    }\n    description\n    subtitle\n    status\n    createdAt\n    updatedAt\n    viewerIsAuthor\n    viewerCanDelete\n    viewerDidUpvote\n    viewerDidComment\n    viewerDidBookmark\n    viewerCanInviteCollaborators\n    viewerCanRemoveCollaborators\n    viewerCanComment\n    commentsCount\n    upvotesCount\n    outcome\n    outcomeStatement\n    vendors {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    groups {\n      _id\n      name\n      logo\n    }\n    itemsCount {\n      products\n      newsworthy\n      attachments\n      locations\n      links\n      vendors\n    }\n    viewerCanEdit\n    viewerCanRead\n    audience\n    outsideProducts {\n      _id\n      name\n      url\n    }\n    attachments {\n      title\n      url\n      mimeType\n      size\n    }\n    newsworthy {\n      title\n      siteName\n      favicon\n      url\n      description\n    }\n    links {\n      title\n      displayTitle\n      description\n      url\n      siteName\n      favicon\n    }\n    products {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    government {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        stateAbbreviation: state\n        state(full: true)\n        governmentType\n        country\n        countryName\n      }\n    }\n    locations {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    locationsPendingVerification {\n      _id\n      slug\n      name\n      logo\n      viewerIsMember\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    collaborators {\n      ... on GovernmentUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        government {\n          _id\n          name\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n      }\n    }\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        government {\n          _id\n          slug\n          name\n          logo\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        company {\n          _id\n          slug\n          name\n          logo\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 94070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57148);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment GroupProjectFields on GroupProject {\n    _id\n    icon\n    title\n    slug\n    tags {\n      _id\n      ...TagFields\n    }\n    awards {\n      _id\n      slug\n      name\n    }\n    description\n    subtitle\n    status\n    createdAt\n    updatedAt\n    viewerIsAuthor\n    viewerCanDelete\n    viewerDidUpvote\n    viewerDidComment\n    viewerDidBookmark\n    viewerCanInviteCollaborators\n    viewerCanRemoveCollaborators\n    viewerCanComment\n    commentsCount\n    upvotesCount\n    outcome\n    outcomeStatement\n    vendors {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    groups {\n      _id\n      name\n      logo\n    }\n    itemsCount {\n      products\n      newsworthy\n      attachments\n      locations\n      links\n      vendors\n    }\n    viewerCanEdit\n    viewerCanRead\n    audience\n    outsideProducts {\n      _id\n      name\n      url\n    }\n    attachments {\n      title\n      url\n      mimeType\n      size\n    }\n    newsworthy {\n      title\n      siteName\n      favicon\n      url\n      description\n    }\n    links {\n      title\n      displayTitle\n      description\n      url\n      siteName\n      favicon\n    }\n    products {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    group {\n      _id\n      slug\n      logo\n      name\n      location\n      viewerIsMember\n    }\n    locations {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    locationsPendingVerification {\n      _id\n      slug\n      name\n      logo\n      viewerIsMember\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    collaborators {\n      ... on GovernmentUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        government {\n          _id\n          name\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n      }\n    }\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        government {\n          _id\n          slug\n          name\n          logo\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        company {\n          _id\n          slug\n          name\n          logo\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 57148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TagFields on Tag {\n    _id\n    slug\n    name\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 4511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57148);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VendorProjectFields on VendorProject {\n    _id\n    icon\n    title\n    slug\n    tags {\n      _id\n      ...TagFields\n    }\n    awards {\n      _id\n      slug\n      name\n    }\n    description\n    subtitle\n    status\n    createdAt\n    updatedAt\n    viewerIsAuthor\n    viewerCanDelete\n    viewerDidUpvote\n    viewerDidComment\n    viewerDidBookmark\n    viewerCanInviteCollaborators\n    viewerCanRemoveCollaborators\n    viewerCanComment\n    commentsCount\n    upvotesCount\n\n    outcome\n    outcomeStatement\n    vendors {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    groups {\n      _id\n      name\n      logo\n    }\n    itemsCount {\n      products\n      newsworthy\n      attachments\n      locations\n      links\n      vendors\n    }\n    viewerCanEdit\n    viewerCanRead\n    audience\n    outsideProducts {\n      _id\n      name\n      url\n    }\n    attachments {\n      title\n      url\n      mimeType\n      size\n    }\n    newsworthy {\n      title\n      siteName\n      favicon\n      url\n      description\n    }\n    links {\n      title\n      displayTitle\n      description\n      url\n      siteName\n      favicon\n    }\n    products {\n      _id\n      logo\n      name\n      description\n      slug\n    }\n    vendor {\n      _id\n      slug\n      logo\n      name\n      description\n      viewerIsMember\n    }\n    locations {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    locationsPendingVerification {\n      _id\n      slug\n      name\n      logo\n      viewerIsMember\n      city {\n        _id\n        name\n        state(full: true)\n        governmentType\n      }\n    }\n    collaborators {\n      ... on GovernmentUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        government {\n          _id\n          name\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n        company {\n          _id\n          name\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        fullName\n        avatar\n        jobTitle\n      }\n    }\n    author {\n      ... on GovernmentUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        government {\n          _id\n          slug\n          name\n          logo\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n        company {\n          _id\n          slug\n          name\n          logo\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        email\n        fullName\n        avatar\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_TagFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 23115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CreateProjectModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29452);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38975);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(56262);
/* harmony import */ var _home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45597);
/* harmony import */ var _home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(82789);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16258);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81871);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78062);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19026);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59496);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27068);
/* harmony import */ var _lib_mutations_CreateProjectForGovernment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18290);
/* harmony import */ var _lib_mutations_CreateProjectForGroup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42191);
/* harmony import */ var _lib_mutations_CreateProjectForVendor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99146);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88196);
/* harmony import */ var _lib_apollo_RefetchQueriesFixLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69086);
/* harmony import */ var final_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60681);
/* harmony import */ var _govlaunch_project_src_form_autoComplete__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55572);
/* harmony import */ var _lib_queries_AutoCompleteGroups__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60942);
/* harmony import */ var _src_components_project_getSelectableAudiences__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62629);
/* harmony import */ var _types_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43845);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69057);






















function CreateProjectModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, groupId = param.groupId;
    var viewer = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_5__/* .useSelfie */ .yD)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var apolloClient = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_16__/* .useApolloClient */ .x)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
    var maxProjects = intl.formatMessage({
        defaultMessage: "Your current plan doesn't support more projects.",
        id: "Mx4aKt"
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_19__/* .useMutation */ .D)(_lib_mutations_CreateProjectForVendor__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), 1), createProjectForVendor = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_19__/* .useMutation */ .D)(_lib_mutations_CreateProjectForGovernment__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), 1), createProjectForGovernment = ref1[0];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_19__/* .useMutation */ .D)(_lib_mutations_CreateProjectForGroup__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), 1), createProjectForGroup = ref2[0];
    var GroupsProvider = _govlaunch_project_src_form_autoComplete__WEBPACK_IMPORTED_MODULE_12__/* .GroupsAutoComplete.Provider */ .z.Provider;
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
        isOpen: isOpen,
        onClose: onClose,
        size: "2xl",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .ModalOverlay */ .ZA, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .ModalContent */ .hz, {
                borderRadius: "md",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .ModalCloseButton */ .ol, {
                        top: -43,
                        right: "4px",
                        size: "xl",
                        _hover: {
                            bg: "transparent"
                        },
                        color: "#FFF"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .fe, {
                        px: 6,
                        py: 4,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(GroupsProvider, {
                            onSearch: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
                                    var queryData;
                                    return _home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return apolloClient.query({
                                                    query: _lib_queries_AutoCompleteGroups__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
                                                    variables: {
                                                        searchQuery: query,
                                                        groupKinds: [
                                                            _types_types__WEBPACK_IMPORTED_MODULE_15__/* .IGroupKind.Vendor */ .Tx.Vendor,
                                                            _types_types__WEBPACK_IMPORTED_MODULE_15__/* .IGroupKind.Community */ .Tx.Community
                                                        ],
                                                        limit: 8
                                                    }
                                                });
                                            case 2:
                                                queryData = _ctx.sent;
                                                return _ctx.abrupt("return", queryData.data.autoCompleteGroups || []);
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(query) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_govlaunch_project__WEBPACK_IMPORTED_MODULE_1__/* .ProjectForm */ .hp, {
                                isVendorProject: viewer.__typename === "VendorUser",
                                getSelectableAudienceOptions: function(values) {
                                    return (0,_src_components_project_getSelectableAudiences__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(values, !!groupId, viewer);
                                },
                                onSubmit: function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
                                        var result, projectSlug, link, ref, result1, projectSlug1, link1, ref1, result2, projectSlug2, link2;
                                        return _home_runner_work_frontend_frontend_node_modules_pnpm_next_12_2_5_cejl76k2qxbp2ab75jaaojpzhe_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (!groupId) {
                                                        _ctx.next = 6;
                                                        break;
                                                    }
                                                    _ctx.next = 3;
                                                    return createProjectForGroup({
                                                        variables: {
                                                            project: values,
                                                            group: groupId
                                                        }
                                                    });
                                                case 3:
                                                    result = _ctx.sent;
                                                    if (result.data && result.data.createProjectForGroup.__typename === "GroupProject") {
                                                        projectSlug = result.data.createProjectForGroup.slug;
                                                        link = (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("/projects/[projectSlug]", {
                                                            projectSlug: projectSlug
                                                        });
                                                        router.push(link, "/projects/".concat(projectSlug));
                                                    }
                                                    return _ctx.abrupt("return");
                                                case 6:
                                                    if (!(viewer.__typename === "VendorUser")) {
                                                        _ctx.next = 18;
                                                        break;
                                                    }
                                                    _ctx.prev = 7;
                                                    ;
                                                    _ctx.next = 11;
                                                    return createProjectForVendor({
                                                        variables: {
                                                            project: values,
                                                            vendor: (ref = viewer.company) === null || ref === void 0 ? void 0 : ref._id
                                                        },
                                                        refetchQueries: (0,_lib_apollo_RefetchQueriesFixLink__WEBPACK_IMPORTED_MODULE_10__/* .refetchQueries */ .h)([
                                                            "CompanyAccountBillingInfo"
                                                        ])
                                                    });
                                                case 11:
                                                    result1 = _ctx.sent;
                                                    if (result1.data) {
                                                        projectSlug1 = result1.data.createProjectForVendor.slug;
                                                        link1 = (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("/projects/[projectSlug]", {
                                                            projectSlug: projectSlug1
                                                        });
                                                        router.push(link1, "/projects/".concat(projectSlug1));
                                                    }
                                                    _ctx.next = 18;
                                                    break;
                                                case 15:
                                                    _ctx.prev = 15;
                                                    _ctx.t0 = _ctx["catch"](7);
                                                    return _ctx.abrupt("return", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, final_form__WEBPACK_IMPORTED_MODULE_11__/* .FORM_ERROR */ .Ck, maxProjects));
                                                case 18:
                                                    if (!(viewer.__typename === "GovernmentUser")) {
                                                        _ctx.next = 24;
                                                        break;
                                                    }
                                                    ;
                                                    _ctx.next = 22;
                                                    return createProjectForGovernment({
                                                        variables: {
                                                            project: values,
                                                            government: viewer.government._id
                                                        }
                                                    });
                                                case 22:
                                                    result2 = _ctx.sent;
                                                    if (((ref1 = result2.data) === null || ref1 === void 0 ? void 0 : ref1.createProjectForGovernment.__typename) === "GovernmentProject") {
                                                        projectSlug2 = result2.data.createProjectForGovernment.slug;
                                                        link2 = (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("/projects/[projectSlug]", {
                                                            projectSlug: projectSlug2
                                                        });
                                                        router.push(link2, "/projects/".concat(projectSlug2));
                                                    }
                                                case 24:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee, null, [
                                            [
                                                7,
                                                15
                                            ]
                                        ]);
                                    }));
                                    return function(values) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 62629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getSelectableAudiences; }
/* harmony export */ });
/* harmony import */ var _types_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43845);

function getSelectableAudiences(values, isWithinGroup, viewer) {
    var hasSelectedGovernments = (values === null || values === void 0 ? void 0 : values.locations.length) > 0;
    if (isWithinGroup && !hasSelectedGovernments) {
        return [
            _types_types__WEBPACK_IMPORTED_MODULE_0__/* .IProjectAudience.Private */ .$A.Private
        ];
    }
    if (viewer.__typename === "VendorUser" && !hasSelectedGovernments) {
        return [
            _types_types__WEBPACK_IMPORTED_MODULE_0__/* .IProjectAudience.Private */ .$A.Private
        ];
    }
    return [
        _types_types__WEBPACK_IMPORTED_MODULE_0__/* .IProjectAudience.Public */ .$A.Public,
        _types_types__WEBPACK_IMPORTED_MODULE_0__/* .IProjectAudience.Community */ .$A.Community,
        _types_types__WEBPACK_IMPORTED_MODULE_0__/* .IProjectAudience.Private */ .$A.Private
    ];
};


/***/ }),

/***/ 36668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ computeNavigationProps; }
/* harmony export */ });
function computeNavigationProps(projects, projectSlug) {
    var projectSlugs = projects.map(function(project) {
        return project.slug;
    });
    if (projectSlugs.length === 1) {
        return {
            previousProjectSlug: undefined,
            nextProjectSlug: undefined
        };
    }
    var currentProjectSlugIndex = projectSlugs.indexOf(projectSlug);
    var previousProjectSlug = projectSlugs[currentProjectSlugIndex - 1];
    var nextProjectSlug = projectSlugs[currentProjectSlugIndex + 1];
    return {
        previousProjectSlug: previousProjectSlug,
        nextProjectSlug: nextProjectSlug
    };
};


/***/ }),

/***/ 96077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProjectModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./intl/locales.ts
var locales = __webpack_require__(30629);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/components/translation/TranslateTo.tsx
var TranslateTo = __webpack_require__(77766);
// EXTERNAL MODULE: ./src/components/project/graphql/ProjectBySlugQuery.ts
var ProjectBySlugQuery = __webpack_require__(94223);
// EXTERNAL MODULE: ./src/components/project/ProjectIsPendingVerification.tsx
var ProjectIsPendingVerification = __webpack_require__(68568);
// EXTERNAL MODULE: ./src/components/project/ProjectWithActions.tsx + 21 modules
var ProjectWithActions = __webpack_require__(63331);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
;// CONCATENATED MODULE: ./src/components/project/modal/KeyboardProjectsNavigation.tsx



function KeyboardProjectsNavigation(param) {
    var navigation = param.navigation;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleKeyUp = function(event) {
            if (event.key === "ArrowLeft" && navigation.previousProjectSlug) {
                router.push((0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                    projectSlug: navigation.previousProjectSlug
                }), "/projects/".concat(navigation.previousProjectSlug));
            }
            if (event.key === "ArrowRight" && navigation.nextProjectSlug) {
                router.push((0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                    projectSlug: navigation.nextProjectSlug
                }), "/projects/".concat(navigation.nextProjectSlug));
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        return function() {
            return window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/project/modal/ChevronLink.tsx





function ChevronLink(param) {
    var children = param.children, projectSlug = param.projectSlug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
            projectSlug: projectSlug
        }),
        as: "/projects/".concat(projectSlug),
        passHref: true,
        scroll: false,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            onClick: function(event) {
                return event.stopPropagation();
            },
            css: {
                display: "block",
                padding: 20
            },
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/project/modal/icons.tsx


function PreviousChevronIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "14",
        height: "39",
        viewBox: "0 0 14 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M12.1333 36.7058L1.86666 19.9411L12.1333 2.29404",
            stroke: "#FAFAF9",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function NextChevronIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "14",
        height: "39",
        viewBox: "0 0 14 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M1.86667 36.7058L12.1333 19.9411L1.86667 2.29404",
            stroke: "#FAFAF9",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/project/modal/ProjectModalNavigation.tsx








function ProjectModalNavigation(param) {
    var navigation = param.navigation;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyboardProjectsNavigation, {
                navigation: navigation
            }, (0,stringOrFirst/* default */.Z)(router.query.projectSlug)),
            navigation.previousProjectSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                position: "absolute",
                top: "calc(50% - 35px)",
                left: 0,
                ml: -52,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronLink, {
                    projectSlug: navigation.previousProjectSlug,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreviousChevronIcon, {})
                })
            }),
            navigation.nextProjectSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                position: "absolute",
                top: "calc(50% - 35px)",
                right: 0,
                mr: -52,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronLink, {
                    projectSlug: navigation.nextProjectSlug,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextChevronIcon, {})
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/project/modal/ProjectModal.tsx












function ProjectModal(param) {
    var projectSlug = param.projectSlug, onClose = param.onClose, onClickProject = param.onClickProject, navigation = param.navigation, lang = param.lang;
    var ref;
    var langExists = typeof lang !== "undefined" && lang.length > 0 && lang !== "en-US";
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var targetLanguage = lang || locale;
    var showTranslateButton = langExists || locale !== "en-US";
    var ref1 = (0,useQuery/* useQuery */.a)(ProjectBySlugQuery/* default */.Z, {
        variables: {
            slug: projectSlug,
            token: null,
            language: (0,locales/* findLanguageByLocale */.Y)(lang)
        },
        fetchPolicy: "network-only"
    }), data = ref1.data, loading = ref1.loading, refetch = ref1.refetch;
    var overlayRef = (0,react.useRef)(null);
    var viewer = (0,Auth/* useSelfie */.yD)();
    var showMakersUpgrade = viewer && viewer.__typename === "VendorUser" && !(data === null || data === void 0 ? void 0 : (ref = data.projectBySlug) === null || ref === void 0 ? void 0 : ref.viewerCanView);
    (0,react.useEffect)(function() {
        var ref;
        (ref = overlayRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0, 0);
    }, [
        projectSlug
    ]);
    var translateToButton = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslateTo/* default */.Z, {
            langExists: langExists,
            showTranslateButton: showTranslateButton,
            refetch: function() {
                return refetch({
                    slug: projectSlug,
                    token: null,
                    language: (0,locales/* findLanguageByLocale */.Y)(targetLanguage)
                });
            },
            refetchOriginal: function() {
                return refetch({
                    slug: projectSlug,
                    token: null,
                    language: null
                });
            }
        });
    };
    var isPendingVerification = (data === null || data === void 0 ? void 0 : data.projectBySlug) && data.projectBySlug.__typename === "VendorProject" && data.projectBySlug.locations.length === 0 && data.projectBySlug.locationsPendingVerification.length > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
        isOpen: true,
        onClose: onClose,
        size: "800px",
        blockScrollOnMount: true,
        scrollBehavior: "outside",
        closeOnEsc: true,
        closeOnOverlayClick: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {
                ref: overlayRef
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                borderRadius: "md",
                ref: overlayRef,
                children: [
                    navigation && !showMakersUpgrade && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectModalNavigation, {
                        navigation: navigation
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalCloseButton */.ol, {
                        top: -43,
                        right: "4px",
                        size: "xl",
                        _hover: {
                            bg: "transparent"
                        },
                        color: "#FFF"
                    }),
                    isPendingVerification && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        position: "relative",
                        mb: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectIsPendingVerification/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalBody */.fe, {
                        pt: 8,
                        pb: 4,
                        px: [
                            1,
                            2,
                            6
                        ],
                        borderRadius: "md",
                        borderBottomWidth: showMakersUpgrade ? 15 : 22,
                        borderBottomColor: showMakersUpgrade ? "white" : "blue.600",
                        onClick: function(event) {
                            return event.stopPropagation();
                        },
                        children: [
                            isPendingVerification && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                height: [
                                    4,
                                    4,
                                    0,
                                    0
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectWithActions/* default */.Z, {
                                loading: loading,
                                onClickProject: onClickProject,
                                project: (data === null || data === void 0 ? void 0 : data.projectBySlug) || null,
                                onVerify: function() {
                                    if (onClose) {
                                        onClose();
                                    }
                                },
                                onDeleteProject: function() {
                                    if (onClose) {
                                        onClose();
                                    }
                                },
                                translationButton: translateToButton,
                                isInModal: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);